import React from 'react';
import {TelehealthSpecialtySelectionProps} from './types';
import {useTelehealthSpecialtyList} from './hooks/useTelehealthSpecialtyList';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingEmptyState} from 'presentation/modules/booking/shared/ui/components/BookingEmptyState';
import {BookingSearchEmptyState} from 'presentation/modules/booking/shared/ui/components/BookingSearchEmptyState';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {TelehealthSpecialtyNotFound} from './components/TelehealthSpecialtyNotFound';
import {TelehealthSpecialtiesList} from './components/TelehealthSpecialtiesList';

const {bookTelehealth} = translations['pt-br'].privateFlow.services;
const {loadingError, loadingState} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;
const {emptyDescription} = translations['pt-br'].commons;

export function TelehealthSpecialtySelection({handleNextStep}: TelehealthSpecialtySelectionProps) {
	const {
		isFetching,
		specialtiesListHasUnprocessableError,
		specialtiesListError,
		refetchSpecialtiesList,
		showEmptyState,
		showNotFoundState,
		specialtiesList,
		mostSearchedSpecialties,
	} = useTelehealthSpecialtyList();

	if (isFetching) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookTelehealth}
				loadingText={loadingState}
			/>
		);
	}

	if (specialtiesListError && !specialtiesListHasUnprocessableError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookTelehealth}
				errorTitle={loadingError}
				handleRefresh={refetchSpecialtiesList}
			/>
		);
	}

	if (showNotFoundState) {
		return <TelehealthSpecialtyNotFound />;
	}

	if (showEmptyState) {
		return (
			<BookingSearchEmptyState
				flowType={FlowEnum.TELEHEALTH}
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_ESPECIALIDADE_ENCONTRADA}>
				<BookingEmptyState
					description={emptyDescription}
					flowType={FlowEnum.TELEHEALTH}
					dataTagId={FinishWithoutCompleteFlowEnum.SEM_ESPECIALIDADE_ENCONTRADA}
				/>
			</BookingSearchEmptyState>
		);
	}

	return (
		<TelehealthSpecialtiesList
			handleNextStep={handleNextStep}
			specialtiesList={specialtiesList!}
			mostSearchedSpecialties={mostSearchedSpecialties}
		/>
	);
}
